// extracted by mini-css-extract-plugin
export default {"carouselItem":"styles_carousel-item_S6sMl","expandButton":"styles_expand-button_JI6wO","modalBackdrop":"styles_modal-backdrop_m6Gto","expandedModal":"styles_expanded-modal_gLuD5"};